import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import HomePage2 from '../HomePage2/HomePage2';
import HomePage3 from '../HomePage3/HomePage3';
import AboutPage from '../AboutPage/AboutPage';
import ServicePages from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import TeamPage from '../TeamPage/TeamPage';
import TeamSinglePage from '../TestimonialPage/TestimonialPage';
import ShopPage from '../ShopPage'
import ProductSinglePage from '../ProductSinglePage';
import CartPage from '../CartPage';
import CheckoutPage from '../CheckoutPage';
import OrderRecived from '../OrderRecived';
import BlogPage from '../BlogPage/BlogPage'
import BlogPageLeft from '../BlogPageLeft/BlogPageLeft' 
import BlogPageFullwidth from '../BlogPageFullwidth/BlogPageFullwidth'
import BlogDetails from '../BlogDetails/BlogDetails'
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide/BlogDetailsLeftSiide'
import BlogDetailsFull from '../BlogDetailsFull/BlogDetailsFull'
import ContactPage from '../ContactPage/ContactPage';
import LoginPage from '../LoginPage/index';
import Register from '../SignUpPage/index';
import ErrorPage from '../ErrorPage/ErrorPage';
import OrderList from '../../components/Order/OrderList';
import OrderForm from '../../components/Order/OrderForm';
import OrderDetail from '../../components/Order/OrderDetail';
import { AuthProvider } from '../context/AuthContext';
import OrderSuccessPage from '../../components/Order/OrderSuccessPage';
import UserList from '../../components/UserList/UserList';
import EditUserForm from '../../components/EditUser/EditUserForm';
import ForgotPassword from '../../components/Password/ForgotPassword'
import ResetPassword from  '../../components/Password/ResetPassword'
const AllRoute = () => {

  return (
    <div className="App">
      <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          
          <Route path="about" element={<AboutPage />} />
          <Route path="services" element={<ServicePages/>} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
         
          <Route path="shop" element={<ShopPage />} />
          <Route path='shop-single/:slug' element={<ProductSinglePage />} />
          
          <Route path='order_received' element={<OrderRecived />} />
         
          
          <Route path='contact' element={<ContactPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="forgot-password" element={<ForgotPassword/>} />
          <Route path="/reset-password/:token" element={<ResetPassword/>} />
          <Route path="register" element={<Register />} />
          <Route path='404' element={<ErrorPage />} />  
          
                  
                  
                    
                      
                      <Route
                        path="/d2f4b9a1-7c38-4d7e-ae1e-938b33d8b75e"
                        element={
                         
                            <OrderList />
                          
                        }
                      />
                      <Route
                        path="/orders/new"
                        element={
                          
                            <OrderForm />
                          
                        }
                      />
                      <Route
                        path="/d2f4b9a1-7c38-4d7e-ae1e-938b33d8b75e/:id"
                        element={
                         
                            <OrderDetail />
                          
                        }
                      />
                      <Route
                        path="/d2f4b9a1-7c38-4d7e-ae1e-938b33d8b75e/:id/edit"
                        element={
                          
                            <OrderForm />
                          
                        }

                      />
                        <Route path="/d2f4b9a1-7c38-4d7e-ae1e-938b33d8b75e34rnbndfg" element={<OrderSuccessPage />} />

                    
                   <Route path="/d2f4b9a1-7c38-4d7e-ae1e-938b33d8b75e/user" element={<UserList />} />
                  
 <Route path="/d2f4b9a1-7c38-4d7e-ae1e-938b33d8b75e/user/edit/:id" element={<EditUserForm />} />
 <Route path="*"  element={<ErrorPage/>} />
 


                
       
        </Routes>
      </BrowserRouter>
</AuthProvider>
    </div>
  );
}

export default AllRoute;
